import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const PromoCareComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="ケア用品・販促品注文完了" content="ケア用品・販促品の注文が完了しました。"  />
      </Layout>
    </React.Fragment>
  )
}

export default PromoCareComplete;